const types = {
  GET_PROVIDER_BY_NAME: '@@IO_SEARCHES/GET_PROVIDER_BY_NAME',
};

export default types;
